import type { SxProps, Theme } from '@mui/material';

const WHATSAPP_GREEN = '#075E54';
const WHATSAPP_BUTTON_GREEN = '#128C7E';
const CHAT_BG = '#e5ddd5';

const styles: Record<string, SxProps<Theme>> = {
  floatingButton: {
    position: 'fixed',
    bottom: 24,
    right: 24,
    width: 56,
    height: 56,
    minWidth: 56,
    borderRadius: '50%',
    zIndex: 1300,
    bgcolor: '#25D366',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    '&:hover': {
      bgcolor: '#1da851',
      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.25)',
    },
  },
  modal: {
    position: 'fixed',
    bottom: 96,
    right: 24,
    width: { xs: 'calc(100vw - 32px)', sm: 360 },
    maxWidth: 360,
    borderRadius: 2,
    overflow: 'hidden',
    boxShadow: '0 8px 28px rgba(0, 0, 0, 0.22)',
    zIndex: 1300,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    bgcolor: WHATSAPP_GREEN,
    color: '#fff',
    px: 1.5,
    py: 1.25,
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
  },
  avatar: {
    width: 40,
    height: 40,
    border: '2px solid rgba(255,255,255,0.3)',
  },
  onlineDot: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 10,
    height: 10,
    borderRadius: '50%',
    bgcolor: '#25D366',
    border: '2px solid #fff',
  },
  body: {
    bgcolor: CHAT_BG,
    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c8c4bc' fill-opacity='0.35'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  messageBubble: {
    bgcolor: '#fff',
    borderRadius: '8px 8px 8px 0',
    p: 1.5,
    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
    alignSelf: 'flex-start',
    maxWidth: '95%',
  },
  input: {
    '& .MuiOutlinedInput-root': {
      bgcolor: '#f0fdf4',
      borderRadius: 1,
      '& fieldset': {
        borderColor: '#d1e7dd',
      },
      '&:hover fieldset': {
        borderColor: '#128C7E',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#128C7E',
      },
    },
  },
  submitButton: {
    bgcolor: WHATSAPP_BUTTON_GREEN,
    color: '#fff',
    fontWeight: 700,
    py: 1.25,
    borderRadius: 1,
    textTransform: 'none',
    fontSize: '1rem',
    '&:hover': {
      bgcolor: '#0e6b5f',
    },
    '&:disabled': {
      bgcolor: '#9e9e9e',
      color: '#fff',
    },
  },
};

export default styles;
